/* eslint-disable */

import axios from "axios";
require("../../config/development");
import Vue from "vue";

import moment from "moment";

const state = {
  kycData: [],
  loading: false,
  fileUrl: null,
  userKycData: null,
  copyUserKycData: null,
  pdf: null,
  cancelChanges: false,
  kycStatus: null,
  croppedImgUrl: null,
  sortByCreatedDate:null,
  sortByUpdatedDate:null,
  tabs: [
    {
      name: "Personal",
      checkDetails: {
        pan_status: false,
        name: false,
        dob: false,
        signature: false
      },
      isReject: true
    },
    {
      name: "Address",
      checkDetails: { address_status: false },
      isReject: true
    },
    {
      name: "IPV",
      checkDetails: { gender: false, video: false },
      isReject: true
    },
    { name: "Approve", isReject: true }
  ]
};
const self = Vue.app;
// getters
const getters = {
  getDetails: state => {
    return state.userKycData;
  },
  getPdfURl: state => {
    return state.pdf;
  },

  getKycDetailsById: state => id => {
    return state.kycData.find(element => element.id === id);
  },

  getFilterKycInfoByStatus: state => status => {
    return state.kycData.filter(
      element => element.kyc_form_check_status === status
    );
  }
};

// actions
const actions = {
  fetchKycData(context, payload) {
    let api = '';
    if(payload == 'submitted') {
      api = 'submitted_kyc_details'
    } else if(payload == 'rejected') {
      api = 'rejected_kyc_details'
    } else {
      api = 'unverified_kyc_details'
    }

    let admin_partner = context.rootGetters.admin_partner
    let end_point = Vue.config.EL_DORADO_API_URL
    if (admin_partner == "az"){
      end_point = Vue.config.EL_DORADO_API_URL_BIGCO
    }
    context.commit("toggleLoading", true);
    return axios
      .get(
        `${end_point}/admin/adfes433fkdfggs343434/kyc/${api}.json`
      )
      .then(response => {
        console.log("kycData res", response)
        context.commit("saveDetails", response);
        context.commit("toggleLoading", false);
      })
      .catch(function(err) {
        context.commit("toggleLoading", false);

        return new Promise((resolve, reject) => reject());
      });
  },

  async kycDetailsByID(context, id) {
    let admin_partner = context.rootGetters.admin_partner
    let end_point = Vue.config.EL_DORADO_API_URL
    if (admin_partner == "az"){
      end_point = Vue.config.EL_DORADO_API_URL_BIGCO
    }

    return axios
      .get(
        `${end_point}/admin/adfes433fkdfggs343434/kyc/${id}.json`
      )
      .then(response => {
        context.commit("SHOW_NOTIFICATION", {
          showNotification: true,
          message: "Data is loaded successfully",
          succesFlag: true
        });
        // context.commit("setNotifyFlag", true);
        context.commit("saveUserKycData", response.data);
        context.commit("saveCopyUserKycData", response.data);
        return response;
      })
      .catch(function() {
        context.commit("SHOW_NOTIFICATION", {
          showNotification: true,
          message: "Error in fetching data..",
          succesFlag: false
        });
      });
  },

  fetchPdf(context, payload) {
    try{
      let admin_partner = context.rootGetters.admin_partner
      let end_point = Vue.config.EL_DORADO_API_URL
      if (admin_partner == "az"){
          end_point = Vue.config.EL_DORADO_API_URL_BIGCO
        }          
        context.commit("SHOW_NOTIFICATION", {
          showNotification: true,
          message: "PDF is loaded successfully",
          succesFlag: true
        });
        let redirect_uri =
          end_point +
          `/admin/adfes433fkdfggs343434/kyc/${payload.id}/${payload.key}.pdf?auth_token=${Vue.vueAuth.getToken()}`;
        window.open(redirect_uri, "_blank");
        context.commit("savePDFUrl", redirect_uri);
      } catch(err) {
        console.log("err in pdf",err)
        context.commit("SHOW_NOTIFICATION", {
          showNotification: true,
          message: "Error in loading pdf..",
          succesFlag: false
        })
      };
  },

  getUrlToken(context) {
    let admin_partner = context.rootGetters.admin_partner
    let end_point = Vue.config.EL_DORADO_API_URL
    if (admin_partner == "az"){
      end_point = Vue.config.EL_DORADO_API_URL_BIGCO
    }   
    return axios
      .get(`${end_point}//api/v3/user/get_token.json`)
      .then(response => new Promise((resolve, reject) => resolve(response)))
      .catch(err => new Promise((resolve, reject) => reject(err)));
  },
  uploadFile(context, payload) {
    let admin_partner = context.rootGetters.admin_partner
    let end_point = Vue.config.EL_DORADO_API_URL
    if (admin_partner == "az"){
      end_point = Vue.config.EL_DORADO_API_URL_BIGCO
    }      
    let formdata = new FormData();
    formdata.append("attachment", payload.file);
    formdata.append("type", payload.file.type);
    axios
      .put(`${end_point}/admin/adfes433fkdfggs343434/upload/file.json`, formdata)
      .then(response => {
        context.commit("SHOW_NOTIFICATION", {
          showNotification: true,
          message: "Successfully upload pdf..",
          succesFlag: true
        });
        let cvl = {
          status: "",
          remarks: "",
          cvl_audit: {
            personal: {
              pan_status: "",
              name: ""
            },
            ipv: {
              gender: "",
              video: ""
            },
            address: {
              address_status: ""
            },
            kyc: {}
          }
        };
        if (
          payload.key == "file_signature" ||
          payload.key === "file_kyc_form"
        ) {
          if (payload.key === "file_kyc_form")
            context.commit("saveFileURL", response.data.file_url);
          cvl.cvl_audit.kyc[payload.key] = response.data.file_url;
        } else {
          cvl.cvl_audit.ipv[payload.key] = response.data.file_url;
        }

        context.dispatch("submitCvlQuery", { data: cvl, id: payload.id });
        context.commit("updateKycDetail", payload);
      })
      .catch(() =>
        context.commit("SHOW_NOTIFICATION", {
          showNotification: true,
          message: "Error in uploading pdf..",
          succesFlag: false
        })
      );
  },
  async uploadImage(context,payload){
    let obj = {name: payload.name,image: payload.image,type:payload.key}
    let admin_partner = context.rootGetters.admin_partner
    let end_point = Vue.config.EL_DORADO_API_URL
    if (admin_partner == "az"){
      end_point = Vue.config.EL_DORADO_API_URL_BIGCO
    }       
    return axios
    .put(`${end_point}/admin/adfes433fkdfggs343434/upload/image.json`, obj)
    .then(response => {
      context.commit("SHOW_NOTIFICATION", {
        showNotification: true,
        message: "Successfully upload image..",
        succesFlag: true
      });
      let cvl = {
        status: "",
        remarks: "",
        cvl_audit: {
          personal: {
            pan_status: "",
            name: ""
          },
          ipv: {
            gender: "",
            video: ""
          },
          address: {
            address_status: ""
          },
          kyc: {}
        }
      };
      if (
        payload.key == "file_signature" ||
        payload.key === "file_kyc_form"
      ) {
        if (payload.key === "file_kyc_form")
          context.commit("saveFileURL", response.data.file_url);
        cvl.cvl_audit.kyc[payload.key] = response.data.file_url;
      } else {
        cvl.cvl_audit.ipv[payload.key] = response.data.file_url;
      }

      context.dispatch("submitCvlQuery", { data: cvl, id: payload.id });
      context.commit("updateKycDetail", payload);
      console.log(response,'inupload')
      return response;
    })
    .catch(() =>
      context.commit("SHOW_NOTIFICATION", {
        showNotification: true,
        message: "Error in uploading image..",
        succesFlag: false
      })
    );
  },
  updateKycDetail(context, payload) {
    let obj = {};
    let kycData = payload.data;
    let cvl = {
      status: "",
      remarks: "",
      cvl_audit: {
        personal: {
          pan_status: "",
          name: ""
        },
        ipv: {
          gender: "",
          video: ""
        },
        address: {
          address_status: ""
        },
        kyc: kycData
      }
    };
    obj.data = cvl;
    obj.id = payload.id;
    context
      .dispatch("submitCvlQuery", obj)
      .then(() =>
        context.commit("SHOW_NOTIFICATION", {
          showNotification: true,
          message: "Successfully update kycInfo..",
          succesFlag: true
        })
      )
      .catch(() =>
        context.commit("SHOW_NOTIFICATION", {
          showNotification: true,
          message: "Error while updating kycInfo..",
          succesFlag: false
        })
      );
  },
  submitCvlQuery(context, payload) {
    console.log({submitdata:payload.data.cvl_audit.kyc})
    if (payload.data.cvl_audit.kyc) {
      if (payload.data.cvl_audit.kyc.date_of_birth)
        payload.data.cvl_audit.kyc.date_of_birth = moment(
          payload.data.cvl_audit.kyc.date_of_birth
        ).format("DD/MM/YYYY");
      if (payload.data.cvl_audit.kyc.validity_doc_poa_corr && moment(payload.data.cvl_audit.kyc.validity_doc_poa_corr).isValid()){
        console.log(payload.data.cvl_audit.kyc.validity_doc_poa_corr);
        console.log(moment(payload.data.cvl_audit.kyc.validity_doc_poa_corr).isValid())
        payload.data.cvl_audit.kyc.validity_doc_poa_corr = moment(
          payload.data.cvl_audit.kyc.validity_doc_poa_corr
        ).format("DD/MM/YYYY");
      }
      console.log(payload.data.cvl_audit.kyc.validity_doc_poa_corr);
    }
    console.log({submitPayload: payload.data.cvl_audit.kyc})
    let data = { cvl: payload.data };
    let admin_partner = context.rootGetters.admin_partner
    let end_point = Vue.config.EL_DORADO_API_URL
    if (admin_partner == "az"){
      end_point = Vue.config.EL_DORADO_API_URL_BIGCO
    }      
    return axios
      .put(
        `${end_point}/admin/adfes433fkdfggs343434/kyc/${payload.id}/cvl_update.json`,
        data
      )
      .then(response => {
        context.dispatch("kycDetailsByID", payload.id);
        Promise.resolve(response);
      })
      .catch(err => Promise.reject(err));
  }
};

// mutations
const mutations = {
  saveDetails(state, payload) {
    state.kycData = payload.data;
  },
  toggleLoading(state, flag) {
    state.loading = flag;
  },

  saveFileURL(state, payload) {
    state.fileUrl = payload;
  },
  savePDFUrl(state, payload) {
    state.pdf = payload;
  },

  saveUserKycData(state, payload) {
    state.userKycData = payload;
  },
  saveCopyUserKycData(state, payload) {
    let data = JSON.parse(JSON.stringify(state.userKycData));

    state.copyUserKycData = data;
  },

  updateKycDetail(state, payload) {
    state.userKycData[payload.key] = payload.value;
  },

  setKycStatus(state, payload) {
    state.kycStatus = payload;
  },
  cancelChanges(state) {
    let data = JSON.parse(JSON.stringify(state.copyUserKycData));
    console.log(data)
    state.userKycData = data;
  },
  removeUserDetails(state) {
    state.userKycData = null;
    state.copyUserKycData = null;
  },
  setcroppedImgUrl(state, payload) {
    state.croppedImgUrl = payload;
  },
  setSortingByDate(state,payload){
    let data = Object.keys(payload)[0];
    state[data] = payload[data];
  },
  toggleReject(state,payload){
    state.tabs[payload.index].isReject = payload.value;
  },
  toggleCheckBox(state,payload){
    state.tabs[payload.index].checkDetails[payload.element] = payload.value
  },
  resetTab(state){
    state.tabs = [
      {
        name: "Personal",
        checkDetails: {
          pan_status: false,
          name: false,
          dob: false,
          signature: false
        },
        isReject: true
      },
      {
        name: "Address",
        checkDetails: { address_status: false },
        isReject: true
      },
      {
        name: "IPV",
        checkDetails: { gender: false, video: false },
        isReject: true
      },
      { name: "Approve", isReject: true }
    ]
  },
  updateTab(state,payload){
    state.tabs = payload;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
